const intObserver = document.querySelectorAll(".int-observer");
const headerLoad = document.querySelectorAll(".header-on-load");
const li = document.querySelectorAll("#syb-main li");
const hr = document.querySelectorAll(".hr");
const options = { rootMargin: "-10%" };

const observer = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      entry.target.classList.add("active");
    }
  });
}, options);

headerLoad.forEach((item) => {
  observer.observe(item);
});

intObserver.forEach((item) => {
  observer.observe(item);
});

li.forEach((item) => {
  observer.observe(item);
});

hr.forEach((item) => {
  observer.observe(item);
});

const stepsBox = document.querySelectorAll(".step");

stepsBox.forEach((item) => {
  item.addEventListener("mousemove", (e) => {
    const rect = item.getBoundingClientRect();
    let x = e.clientX - rect.left;
    let y = e.clientY - rect.top;

    item.style.setProperty("--pos-x", `${x}px`);
    item.style.setProperty("--pos-y", `${y}px`);
  });
});
